(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["email-capture-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-kf-capture-popup]');
  if (!root) return;
  const dialog = root.querySelector('dialog');
  const closeButton = root.querySelector('[data-kf-capture-close]');
  const goButton = root.querySelector('[data-kf-capture-go]');
  const storageKey = 'kickfitz_email_capture_seen_v1';
  const cooldown = 7 * 24 * 60 * 60 * 1000;

  function remember() {
    try { localStorage.setItem(storageKey, String(Date.now())); } catch (error) {}
  }

  try {
    const lastSeen = Number(localStorage.getItem(storageKey) || 0);
    if (lastSeen && Date.now() - lastSeen < cooldown) return;
  } catch (error) {}

  if (document.querySelector('[data-capture-success]')) {
    remember();
    return;
  }

  root.hidden = false;

  window.setTimeout(() => {
    if (!dialog.open) dialog.showModal();
  }, 8000);

  if (closeButton) {
    closeButton.addEventListener('click', () => {
      remember();
      dialog.close();
    });
  }

  if (goButton) {
    goButton.addEventListener('click', () => {
      remember();
      if (dialog.open) dialog.close();
    });
  }

  dialog.addEventListener('cancel', remember);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-color-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kickfitz-color-preview')) {
  customElements.define('kickfitz-color-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.image = this.closest('.product')?.querySelector('.product-photo img');
      this.productLink = this.closest('.product')?.querySelector('.product-button');
      if (!this.image || !this.productLink) return;
      this.original = Object.fromEntries(['src', 'srcset', 'sizes', 'alt'].map(key => [key, this.image.getAttribute(key)]));
      this.originalHref = this.productLink.getAttribute('href');
      this.sequence = 0;
      this.querySelectorAll('.kf-card-swatch').forEach(link => {
        link.setAttribute('role', 'button');
        link.setAttribute('aria-pressed', 'false');
      });
      this.addEventListener('click', event => {
        const swatch = event.target.closest('.kf-card-swatch');
        if (!swatch || !this.contains(swatch)) return;
        event.preventDefault();
        event.stopPropagation();
        this.selected = swatch.closest('.kf-card-color');
        this.querySelectorAll('.kf-card-swatch').forEach(link => link.setAttribute('aria-pressed', String(link === swatch)));
        this.show(this.selected);
      });
      this.addEventListener('keydown', event => {
        const swatch = event.target.closest('.kf-card-swatch');
        if (swatch && event.key === ' ') { event.preventDefault(); swatch.click(); }
      });
      this.addEventListener('pointerover', event => {
        if (event.pointerType === 'touch') return;
        const item = event.target.closest('.kf-card-color');
        if (item) this.show(item);
      });
      this.addEventListener('pointerleave', () => this.show(this.selected));
      this.addEventListener('focusin', event => this.show(event.target.closest('.kf-card-color')));
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) this.show(this.selected);
      });
    }
    show(item) {
      const sequence = ++this.sequence;
      this.querySelectorAll('.is-previewing').forEach(element => element.classList.remove('is-previewing'));
      const url = item?.dataset.kfPreview;
      if (!url) {
        for (const [key, value] of Object.entries(this.original)) {
          if (value === null) this.image.removeAttribute(key); else this.image.setAttribute(key, value);
        }
        this.productLink.setAttribute('href', this.selected?.querySelector('.kf-card-swatch')?.getAttribute('href') || this.originalHref);
        return;
      }
      item.classList.add('is-previewing');
      this.productLink.setAttribute('href', item.querySelector('.kf-card-swatch').getAttribute('href') || this.originalHref);
      const image = new Image();
      image.onload = () => {
        if (sequence !== this.sequence || !this.isConnected) return;
        this.image.removeAttribute('srcset');
        this.image.removeAttribute('sizes');
        this.image.src = url;
        this.image.alt = item.dataset.kfPreviewAlt || this.original.alt || '';
      };
      image.src = url;
    }
    disconnectedCallback() { this.sequence++; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kickfitz-gallery')){
  customElements.define('kickfitz-gallery',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.photos=[...this.querySelectorAll('[data-kf-photo]')];
      this.dialog=this.querySelector('dialog');
      this.stage=this.querySelector('.kf-viewer-stage');
      this.large=this.querySelector('[data-kf-large]');
      this.zoom=this.querySelector('[data-kf-zoom]');
      this.index=0;
      this.addEventListener('click',event=>{
        const link=event.target.closest('[data-kf-photo]');
        if(link&&!event.ctrlKey&&!event.metaKey&&!event.shiftKey){
          event.preventDefault();this.opener=link;this.show(this.photos.indexOf(link));
          this.previousOverflow=document.documentElement.style.overflow;
          document.documentElement.style.overflow='hidden';this.dialog.showModal();return;
        }
        if(event.target.closest('[data-kf-close]'))this.dialog.close();
        if(event.target.closest('[data-kf-prev]'))this.show(this.index-1);
        if(event.target.closest('[data-kf-next]'))this.show(this.index+1);
        if(event.target.closest('[data-kf-zoom]')||event.target===this.large){
          const active=this.stage.classList.toggle('is-zoomed');
          this.zoom.setAttribute('aria-pressed',String(active));
          if(!active)this.stage.scrollTo(0,0);
        }
      });
      this.dialog.addEventListener('close',()=>{
        document.documentElement.style.overflow=this.previousOverflow||'';
        this.opener?.focus({preventScroll:true});
      });
      this.dialog.addEventListener('keydown',event=>{
        if(this.stage.classList.contains('is-zoomed'))return;
        if(event.key==='ArrowLeft'){event.preventDefault();this.show(this.index-1)}
        if(event.key==='ArrowRight'){event.preventDefault();this.show(this.index+1)}
      });
      this.stage.addEventListener('touchstart',event=>{
        this.startTouch=event.touches.length===1?{x:event.touches[0].clientX,y:event.touches[0].clientY}:null;
      },{passive:true});
      this.stage.addEventListener('touchend',event=>{
        if(!this.startTouch||this.stage.classList.contains('is-zoomed')||event.changedTouches.length!==1)return;
        const dx=event.changedTouches[0].clientX-this.startTouch.x;
        const dy=event.changedTouches[0].clientY-this.startTouch.y;
        if(Math.abs(dx)>70&&Math.abs(dx)>Math.abs(dy)*1.5)this.show(this.index+(dx<0?1:-1));
        this.startTouch=null;
      },{passive:true});
    }
    show(index){
      this.index=(index+this.photos.length)%this.photos.length;
      const link=this.photos[this.index],img=link.querySelector('img');
      this.large.src=link.href;this.large.alt=img.alt;
      this.querySelector('[data-kf-caption]').textContent=img.alt;
      this.querySelector('[data-kf-count]').textContent=(this.index+1)+' / '+this.photos.length;
      this.stage.classList.remove('is-zoomed');this.zoom.setAttribute('aria-pressed','false');this.stage.scrollTo(0,0);
      this.querySelector('[data-kf-prev]').hidden=this.photos.length<2;
      this.querySelector('[data-kf-next]').hidden=this.photos.length<2;
    }
    disconnectedCallback(){if(this.dialog?.open)document.documentElement.style.overflow=this.previousOverflow||''}
  });
}

if(!customElements.get('kickfitz-product-colors')){
  customElements.define('kickfitz-product-colors',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.gallery=this.previousElementSibling;
      if(!this.gallery?.matches('kickfitz-gallery'))return;
      this.link=this.gallery.querySelector('[data-kf-photo]');
      this.image=this.link?.querySelector('img');
      if(!this.image)return;
      this.ready=true;
      this.gallery.append(this);
      this.gallery.classList.add('kf-compact-gallery');
      this.sequence=0;
      this.original=Object.fromEntries(['src','srcset','sizes','alt'].map(key=>[key,this.image.getAttribute(key)]));
      this.originalHref=this.link.getAttribute('href');
      this.originalLabel=this.link.getAttribute('aria-label');
      this.image.loading='eager';
      this.selects=[...this.closest('.product-layout').querySelectorAll('[data-option-select]')];
      const buttons=[...this.querySelectorAll('a.kf-card-swatch')];
      this.colorSelect=this.selects.find(select=>buttons.some(button=>[...select.options].some(option=>option.textContent.trim()===button.title)));
      this.selectedName=this.colorSelect?.selectedOptions[0]?.textContent.trim();
      buttons.forEach(button=>{
        button.setAttribute('role','button');
        button.setAttribute('aria-pressed',String(button.title===this.selectedName));
      });
      this.addEventListener('pointerover',event=>{
        if(event.pointerType==='touch')return;
        const item=event.target.closest('.kf-card-color');
        if(item&&!item.contains(event.relatedTarget))this.preview(item);
      });
      this.addEventListener('pointerout',event=>{
        const item=event.target.closest('.kf-card-color');
        if(item&&!item.contains(event.relatedTarget))this.preview(null);
      });
      this.addEventListener('focusin',event=>this.preview(event.target.closest('.kf-card-color')));
      this.addEventListener('focusout',()=>this.preview(null));
      this.addEventListener('click',event=>{
        const button=event.target.closest('a.kf-card-swatch');
        if(!button||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        if(!this.colorSelect)return;
        const option=[...this.colorSelect.options].find(option=>option.textContent.trim()===button.title);
        if(!option)return;
        event.preventDefault();
        event.stopPropagation();
        if(option.selected){this.preview(null);return;}
        this.colorSelect.value=option.value;
        this.colorSelect.dispatchEvent(new Event('change',{bubbles:true}));
      });
      this.addEventListener('keydown',event=>{
        const button=event.target.closest('a.kf-card-swatch');
        if(button&&event.key===' '){event.preventDefault();button.click();}
      });
    }
    preview(item){
      if(this.gallery.querySelector('[data-kf-back-view]'))return;
      const sequence=++this.sequence;
      this.querySelectorAll('.is-previewing').forEach(element=>element.classList.remove('is-previewing'));
      const restore=()=>{
        for(const [key,value] of Object.entries(this.original)){
          if(value===null)this.image.removeAttribute(key);else this.image.setAttribute(key,value);
        }
        this.link.setAttribute('href',this.originalHref);
        this.link.setAttribute('aria-label',this.originalLabel);
      };
      if(!item?.dataset.kfPreview){restore();return;}
      item.classList.add('is-previewing');
      const source=new URL(item.dataset.kfPreview,location.href);
      source.searchParams.set('width','1400');
      const preload=new Image();
      preload.onload=()=>{
        if(sequence!==this.sequence||!this.isConnected)return;
        this.image.removeAttribute('srcset');this.image.removeAttribute('sizes');
        this.image.src=source.href;
        this.image.alt=item.dataset.kfPreviewAlt||this.original.alt||'';
        source.searchParams.set('width','3000');
        this.link.href=source.href;
        this.link.setAttribute('aria-label',this.image.alt);
      };
      preload.onerror=()=>{if(sequence===this.sequence)restore();};
      preload.src=source.href;
    }
    disconnectedCallback(){this.sequence++;}
  });
}
  } catch(e) { console.error(e); }
})();

})();
